<template>
  <div class="userInfo">
    <div class="changeAvatar">
      <el-upload
        class="avatar-uploader"
        :data="headImg"
        :action="apis"
        :show-file-list="false"
        :before-upload="beforeUpload"
        :on-success="handleAvatarSuccess"
      >
        <img
          style="height: 134px; width: 134px"
          v-if="form.headImage"
          :src="form.headImage"
          class="avatar"
        />
        <img
          v-else
          style="height: 134px; width: 134px"
          src="https://static.xhngyl.com/xhngyl-platform-gy/avatar/2021-08-24/4588b24faf4c4588a0878eeef5fcd4b3-avatar.png"
          alt=""
        />
        <i style="color: #f77b0b" class="el-icon-plus avatar-uploader-icon"></i>
        <!-- <span class="avatarTit">更换头像</span> -->
      </el-upload>
    </div>
    <div class="userNameBox userBlock">
      <label>性别：</label>
      <el-radio v-model="form.sex" :label="1">男</el-radio>
      <el-radio v-model="form.sex" :label="2">女</el-radio>
    </div>
    <div class="bindPhoneBox userBlock">
      <label>手机号：</label>
      <div class="phoneInfo">
        <span>{{ form.phone }}</span>
        <el-button size="mini" @click="weixinCode()">绑定微信</el-button>
        <!-- <span @click="$router.push('/changePhone')">更换</span> -->
      </div>
    </div>
    <div class="userNameBox userBlock">
      <label>用户名：</label>
      <el-input
        style="width: 250px"
        v-model="form.account"
        placeholder="请输入内容"
        :disabled="true"
      ></el-input>
      <!-- <el-input
        v-else
        v-model="form.name"
        placeholder="请输入内容"
        
      ></el-input> -->
    </div>

    <div class="birthTimeBox userBlock">
      <label>出生日期：</label>
      <el-date-picker
        v-model="form.birthday"
        type="date"
        placeholder="选择日期"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
    </div>

    <div class="userInfoSave" @click="saveUserInfo" v-throttle>保存</div>

    <el-dialog
      :visible.sync="weixinCodeDiog"
      width="40%"
      style="padding-bottom: 30px"
    >
      <div
        style="
          display: flex;
          justify-content: space-between;
          width: 100%;
          padding: 10px 40px;
        "
      >
        <div style="width: 47%; text-align: center">
          <img
            src="../../../assets/images/QR-public.png"
            alt=""
            style="width: 230px; margin-top: -15px"
          />
          <div>
            <span class="qrText">1</span>
            <span style="color:#333333;margin-left:5px;">请扫码关注</span>
          </div>
        </div>
        <div style="width: 6%; text-align: center; padding-top: 90px">
          <i
            class="el-icon-arrow-right"
            style="font-size: 30px; color: #606266"
          ></i>
        </div>
        <div style="width: 47%; text-align: center">
          <vue-qr
            :size="200"
            :margin="0"
            :auto-color="true"
            :dot-scale="1"
            :text="appSrc"
          />
          <div style="margin-top: 15px">
            <span  class="qrText">2</span>
            <span style="color:#333333;margin-left:5px;">扫码绑定微信</span>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer" style="padding-right: 80px">
        <el-button @click="weixinCodeDiog = false">取 消</el-button>
        <el-button type="primary" @click="weixinCodeDiog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import imagesUrl from "../../../assets/imagesUrl";
import api from "../../../api";
import { listSearchMixin } from "@/config/mixin";
import { mapGetters, mapMutations } from "vuex";
import VueQr from "vue-qr";
export default {
  mixins: [listSearchMixin],
  name: "userInfo",
  components: {
    VueQr,
  },
  data() {
    return {
      headImg:{
        filePath:1
      },
      action: api.upload,
      headUrl: imagesUrl.avatar,
      userName: "Curmudgeons",
      gender: "1",
      birthTime: "",
      userInfoData: {},
      avatarImg: "",
      weixinCodeDiog: false,
      appSrc: "",
      form: {
        // name: "",
        // sex: 1,
        // birthday: "",
        // account: "",
        // buyerUserId: this.userInfo.buyerUserId,
        // headImage: "",
        // id: "",
        // phone: "",
      },
    };
  },
  mounted() {
    this.getUserInfo();
    this.userInfoData = JSON.parse(JSON.stringify(this.userInfo));
  },
  computed: {
    ...mapGetters([
      "userInfo", // 用户信息
    ]),
    apis() {
      return api.upload;
    },
  },
  methods: {
    ...mapMutations({
      setUserInfo: "SET_USERINFO", // 修改用户信息
      setAVATR: "SET_AVATAR", // 修改用户信息
    }),
    weixinCode() {
      this.weixinCodeDiog = true;
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "application/pdf";
      if (!isJpgOrPng) {
        this.$message.error("文件需为jpg/png/pdf格式");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不可以超过2M");
      }
      return isJpgOrPng && isLt2M;
    },
    getUserInfo() {
      let self = this;
      let params = {
        url: api.getUserInfo,
        method: "post",
        data: {
          buyerUserId: this.userInfo.buyerUserId,
        },
      };

      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.form = res.data;
          self.appSrc = res.data.wxServiceAuthQrUrl;
          self.form.name = res.data.account;
          if (res.data.sex) {
            self.form.sex = res.data.sex;
          } else {
            res.form.sex = 1;
          }
          self.setUserInfo(res.data);

          self.userInfoData = JSON.parse(JSON.stringify(res.data));
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    saveUserInfo() {
      // if(this.form.name == ''){
      //   this.$message({
      //       message: "昵称不能为空",
      //       type: "warning",
      //     });
      //     return;
      // }
      // console.log(this.userInfo, 'userInfo')
      let self = this;
      self.form.name = self.form.account;
      let params = {
        url: api.editUserInfo,
        method: "post",
        data: self.form,
        // {
        //   name: self.form.name,
        //   sex: self.form.sex,
        //   birthday: self.form.birthday,
        //   account: self.form.account,
        //   buyerUserId: self.form.buyerUserId,
        //   headImage: self.form.headImage,
        //   id: self.form.id,
        //   phone: self.form.phone
        //   // ...self.userInfoData,

        // },
      };

      // self.setUserInfo(self.form)
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.$message({
            message: "修改成功！",
            type: "success",
          });

          this.getUserInfo();
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    // 上传头像
    handleAvatarSuccess(res) {
      this.setAVATR(res.data.url);
      this.form.headImage = res.data.url;
      // this.saveUserInfo()
    },
  },
};
</script>

<style lang="scss" scoped>
>>>.el-dialog__footer {
  padding: 0 20px 30px !important;
}
.qrText {
  width: 24px;
  height: 23px;
  display: inline-block;
  padding: 0px;
  border: 1px solid #f77b0b;
  border-radius: 13px;
  color: #f77b0b;
}
.userInfo {
  padding: 30px;
  // border: 1px solid #E5E5E5;
  .changeAvatar {
    width: 134px;
    height: 134px;
    position: relative;
    border: 1px dashed #f77b0b;
    border-radius: 4px;
    overflow: hidden;
    .avatar-uploader-icon {
      display: none;
    }
    .avatar {
      width: 100%;
    }
    .avatarTit {
      height: 30px;
      line-height: 30px;
      position: absolute;
      bottom: 0;
      font-size: 16px;
      background: rgba(84, 84, 84, 0.5);
      width: 100%;
      text-align: center;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .changeAvatar:hover {
    border-color: #f7790ba2;
    .avatar-uploader:before {
      cursor: pointer;
      content: "";
      display: inline-block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: #9e9e9e99;
    }
    .avatar-uploader-icon {
      display: inline-block;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -15px;
      margin-top: -15px;
    }
    .avatar-uploader-icon::before {
      color: #f7790ba2;
      font-size: 30px;
    }
  }
  .userNameBox {
    >>> .el-input {
      width: 180px;
    }
  }
  .userBlock {
    margin-top: 30px;
    display: flex;
    align-items: center;
    label {
      font-weight: normal;
      font-size: 16px;
      color: #666666;
    }
  }
  .bindPhoneBox {
    .phoneInfo {
      font-size: 16px;
      span {
        margin-right: 15px;
        text-decoration: underline;
        cursor: pointer;
      }
      span:nth-child(1) {
        color: #333333;
        text-decoration: none;
        cursor: default;
      }
      span:nth-child(2) {
        color: $mainColor;
      }
      span:nth-child(3) {
        color: #666666;
      }
    }
  }
  .userInfoSave {
    margin: 50px 0 0 80px;
    width: 115px;
    height: 30px;
    line-height: 30px;
    background: #ffffff;
    border: 1px solid $mainColor;
    border-radius: 4px;
    text-align: center;
    color: $mainColor;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/userInfo/userInfo.vue